import classNames from 'classnames'
import { type FC } from 'react'
import { Icon, Tooltip, Dropdown } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { commonTooltipProps } from '../../constants/menuItems'

import styles from './styles.module.scss'

const ProductUpdatesDropdown: FC = () => {
  return (
    <Dropdown
      ariaLabel={'ProductUpdatesDropdown'}
      width={186}
      icon={'question'}
      placement={'right-end'}
      variantTriggerButton={'icon'}
      triggerComponent={(open) => (
        <Tooltip label={'Product updates'} {...commonTooltipProps}>
          <div
            className={classNames(styles.button, {
              [styles.active]: open,
            })}
            data-canny-changelog
            aria-label={getAriaLabel('ProductUpdatesDropdownTrigger')}
          >
            <Icon icon={'announcement'} fontSize={20} />
          </div>
        </Tooltip>
      )}
      customComponent={() => <></>}
    />
  )
}

export { ProductUpdatesDropdown }
